import { View } from 'foundations-components/components/View';
import styled, { useTheme } from 'foundations-theming/utils';

// @ts-expect-error Untyped import
import circlesImageUrl from 'bender-url!../../images/white-circle-3.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const BackgroundWrapper = styled.div.withConfig({
  displayName: "ColorCirclesHeader__BackgroundWrapper",
  componentId: "sc-1uzye7n-0"
})(({
  containerHeight,
  containerWidth,
  height = '100%',
  left = '0',
  padding = '55px 0 65px 0',
  setBackgroundColor,
  transform,
  top = '0',
  width = '100%'
}) => ({
  backgroundColor: setBackgroundColor,
  padding,
  position: 'relative',
  height: containerHeight,
  width: containerWidth,
  '&::before': {
    content: '""',
    display: 'block',
    top,
    left,
    width,
    height,
    position: 'absolute',
    backgroundImage: `url(${circlesImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundBlendMode: 'overlay',
    opacity: 0.07,
    zIndex: 0,
    transform
  }
}));
const ColorCirclesHeader = ({
  backgroundColor = 'fill-accent-teal-default',
  children,
  containerHeight,
  containerWidth,
  height,
  left,
  padding,
  top,
  transform,
  width
}) => {
  const theme = useTheme();
  const setBackgroundColor = backgroundColor === 'transparent' ? 'transparent' : theme.color[backgroundColor];
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(BackgroundWrapper, {
      containerHeight: containerHeight,
      containerWidth: containerWidth,
      height: height,
      left: left,
      padding: padding,
      setBackgroundColor: setBackgroundColor,
      top: top,
      transform: transform,
      width: width,
      children: /*#__PURE__*/_jsx(View, {
        position: "relative",
        children: children
      })
    })
  );
};
export default ColorCirclesHeader;